import React from 'react';
import PropTypes from 'prop-types';
import { formMessageConstants } from '../../../utils/constants/form-message-constants';

function Order({
    orderItem,
    orderTypeValues,
    fileStateValues,
    onViewFileDetailsClick
}) {
    function handleViewFileDetailsClick(event, fileNumber) {
        event.preventDefault();
        onViewFileDetailsClick(fileNumber);
    }

    function displayOrderItem() {
        return (
            <li >
                <div className='info'>
                    <div className='my-account-tag'>{orderTypeValues[orderItem.orderTypeIndex]}</div>
                    <p>
                        <span className='left'>{formMessageConstants.fileNumber}</span>
                        <span className='right'>{orderItem.fileNumber}</span>
                    </p>
                    <p>
                        <span className='left'>{formMessageConstants.fileStatus}</span>
                        <span className='right'>{fileStateValues[orderItem.fileStateIndex]}</span>
                    </p>
                    <p>
                        <span className='left'>{formMessageConstants.lastUpdate}</span>
                        <span className='right'>{orderItem.formattedLastUpdate}</span>
                    </p>
                    <p>
                        <span className='left'>{formMessageConstants.fileAmount}</span>
                        <span className='right'>{orderItem.formattedFileAmount}</span>
                    </p>
                </div>
                <div className='bottom'>
                    <a className='see-details' href='#' onClick={(event) => { handleViewFileDetailsClick(event, orderItem.fileNumber); }}>
                        <span className='ico'>
                            <svg aria-hidden='true' focusable='false' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'
                                className='icon'>
                                <path fill='currentColor'
                                    d='M295.515 115.716l-19.626 19.626c-4.753 4.753-4.675 12.484.173 17.14L356.78 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h344.78l-80.717 77.518c-4.849 4.656-4.927 12.387-.173 17.14l19.626 19.626c4.686 4.686 12.284 4.686 16.971 0l131.799-131.799c4.686-4.686 4.686-12.284 0-16.971L312.485 115.716c-4.686-4.686-12.284-4.686-16.97 0z'
                                    className=''></path>
                            </svg>
                        </span>
                        <span className='text'>{formMessageConstants.viewFileDetails}</span>
                    </a>
                </div>
            </li>
        );
    }

    return displayOrderItem();
}

Order.propTypes = {
    orderItem: PropTypes.object.isRequired,
    orderTypeValues: PropTypes.object.isRequired,
    fileStateValues: PropTypes.object.isRequired,
    onViewFileDetailsClick: PropTypes.func.isRequired
};

export default Order;
